import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input,
  OnInit
} from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';

import { FlipperSidesModel }                   from '../shared/components/flipper/typings/flipper.sides';
import { MessagesService }                     from '../messages/messages.service';
import { Table }                               from '../table/types/table';
import { VehicleVisualModel }                  from './typings/vehicle-visuals';
import { VehicleVisualsCatalogSelectionModel } from './typings/vehicle-visuals.selection';
import { VehicleVisualsLevel }                 from './typings/vehicle-visuals.level';
import { VehicleVisualsService }               from './vehicle-visuals.service';

@Component({
  selector   : 'wor-vehicle-visuals-catalog-modal',
  template: require('./vehicle-visuals.catalog-modal.component.html')
})
export class VehicleVisualsCatalogModalComponent implements OnInit {
  @BlockUI('vehicleVisualsCatalogModalBlock') block : NgBlockUI;

  @Input() interactive = false;

  activeSide      : FlipperSidesModel         = 'front';
  catalog         : Array<VehicleVisualModel> = [];
  query           = '';
  searchResults   : Array<VehicleVisualModel> = [];
  searchSelection : VehicleVisualModel | null = null;

  selection : VehicleVisualsCatalogSelectionModel = this.vehicleVisualsService.emptySelection();

  tableSettings : Table = {
    ...this.vehicleVisualsService.searchResultsTableSettings(),
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    }
  };

  constructor (
    public  activeModal          : NgbActiveModal,
    private changeDetectorRef    : ChangeDetectorRef,
    private messagesService      : MessagesService,
    @Inject(forwardRef(() => VehicleVisualsService))
    private vehicleVisualsService: VehicleVisualsService
  ) {}

  ngOnInit () : void {
    this.getCatalog();
  }

  flip ( side : FlipperSidesModel ) : void {
    this.activeSide = side;

    this.changeDetectorRef.detectChanges();
  }

  getCatalog () : void {
    this.block.start();

    this.vehicleVisualsService.getCatalog(this.interactive)
    .then(( catalog : Array<VehicleVisualModel> ) => {
      this.catalog = catalog;
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  onRowClick () : void {
    this.searchSelection = this.searchResults.find(( row : VehicleVisualModel ) => row.selected) || null;
  }

  // The list box toggles the item it emits, so a second click on it clears the level.
  onSelect ( level : VehicleVisualsLevel, visual : VehicleVisualModel ) : void {
    this.clearSelectedFlags(level);

    this.selection = this.vehicleVisualsService.selectLevel(this.selection, level, visual.selected
      ? visual
      : null);
  }

  search () : void {
    this.searchResults   = [];
    this.searchSelection = null;

    this.vehicleVisualsService.search(this.query)
    .then(( results : Array<VehicleVisualModel> ) => {
      this.searchResults = results;
    })
    .catch(error => this.messagesService.error(error));
  }

  select ( visual : VehicleVisualModel | null = this.selectedVisual() ) : void {
    if ( visual ) {
      this.activeModal.close({
        interactive: this.interactive,
        visual
      });
    }
  }

  // The list box re-selects any item still flagged when its items change.
  private clearSelectedFlags ( level : VehicleVisualsLevel ) : void {
    if ( level === 'system' ) {
      this.selection.system?.children?.forEach(( part : VehicleVisualModel ) => {
        part.selected = false;
      });
    }

    if ( level !== 'defect' ) {
      this.selection.part?.children?.forEach(( defect : VehicleVisualModel ) => {
        defect.selected = false;
      });
    }
  }

  private selectedVisual () : VehicleVisualModel | null {
    return this.activeSide === 'back'
      ? this.searchSelection
      : this.selection.defect || this.selection.part || this.selection.system;
  }
}
